// extracted by mini-css-extract-plugin
module.exports = {"subregionHeader":"SubregionHeaderLink_subregionHeader__k29sl","subregionHeaderMap":"SubregionHeaderLink_subregionHeaderMap__CrPHq"};